// src/context/PostAdContext.js
import React, { createContext, useContext, useState, useCallback } from 'react';

// 1. Create the Context
const PostAdContext = createContext({
  step: 1,
  setStep: () => console.error("CRITICAL: setStep called outside of Provider!"),
  adData: {},
  setFlowType: () => console.error("CRITICAL: setFlowType called outside of Provider!"),
  flowType: null,
  selectedCategory: null,
  setAdData: () => console.error("CRITICAL: setAdData called outside of Provider!"),
  resetFlow: () => {}
});

// 2. The Provider Component
export const PostAdProvider = ({ children }) => {
  const [step, setStep] = useState(1);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [flowType, setFlowType] = useState(null); // 'AI' or 'MANUAL'
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [photos, setPhotos] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [adData, setAdData] = useState({});
  const [location, setLocation] = useState(null);

  const resetFlow = useCallback(() => {
    setStep(1);
    setFlowType(null);
    setSelectedCategory(null);
    setSelectedSubCategory(null);
    setPhotos([]);
    setPreviews([]);
    setAdData({});
    setIsAnalyzing(false);
    setLocation(null);
  }, []);

  // Combine everything into a single object
  const contextValue = {
    step, setStep,
    isAnalyzing, setIsAnalyzing,
    flowType, setFlowType,
    selectedCategory, setSelectedCategory,
    selectedSubCategory, setSelectedSubCategory,
    photos, setPhotos,
    previews, setPreviews,
    adData, setAdData,
    location, setLocation,
    resetFlow
  };

  return (
    <PostAdContext.Provider value={contextValue}>
      {children}
    </PostAdContext.Provider>
  );
};

// 3. The Hook
export const usePostAd = () => {
  const context = useContext(PostAdContext);
  return context;
};